import { useQuery } from '@tanstack/react-query';

import type { StopType } from '@/types';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

const useGetStationListData = (options = {}) =>
  useQuery<StopType[]>({
    queryKey: ['stops'],
    queryFn: async () => {
      const response = await axiosInstance.get(API_ROUTES.stationLists());

      return response.data;
    },
    gcTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
    retry: false,
    ...options,
  });

export default useGetStationListData;
